import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface StaffState {
  isBackPaddockStaff: boolean;
}

const initialState: StaffState = {
  isBackPaddockStaff: false,
};

const staffSlice = createSlice({
  name: 'staff',
  initialState,
  reducers: {
    setIsBackPaddockStaff: (state, action: PayloadAction<boolean>) => {
      state.isBackPaddockStaff = action.payload;
    },
    clearStaffState: () => initialState,
  },
});

export const { setIsBackPaddockStaff, clearStaffState } = staffSlice.actions;

export default staffSlice.reducer;
